interface ReferenceUnresolvedContentProps {
  reason?: string;
  message?: string | null;
  title?: string;
}

const formatReasonLabel = (reason?: string) => {
  if (!reason) return 'Reference unavailable';
  return reason
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (character) => character.toUpperCase())
    .trim();
};

export const ReferenceUnresolvedContent = ({
  reason,
  message,
  title = 'Reference unavailable',
}: ReferenceUnresolvedContentProps) => {
  return (
    <div
      className="bg-background mx-auto max-w-2xl rounded-lg p-6 shadow-sm"
      role="region"
      aria-label={title}
    >
      <h2 className="text-foreground text-lg font-semibold">{title}</h2>
      <p className="text-foreground mt-2 text-sm">
        {formatReasonLabel(reason)}
      </p>
      {message ? (
        <p className="text-muted-foreground mt-2 text-sm">{message}</p>
      ) : null}
    </div>
  );
};
